module.exports = __webpack_public_path__ + "static/media/Next White Logo.cc5b7b1f.svg";